import { Component, OnInit, Input, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdditionalPublicLibraryService } from 'src/app/core/services/additional-public-library.service';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RemoveContent } from 'src/app/components/private-library/remove-content/remove-content.component';
import { saveAsPng } from 'save-html-as-image';

@Component({
  selector: 'app-qr-code-modal',
  templateUrl: './qr-code-modal.component.html',
  styleUrls: ['./qr-code-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QrCodeModalComponent implements OnInit {

  qrForm: FormGroup;
  submitted: boolean = false;
  timeMatrices = [];
  qrCodes = [];
  @Input() public user;
  selectedQRcode;
  selectedQRcodeHTML;
  isLoading = false;
  @ViewChild('qrCodeDownload', { static: false }) qrCodeDownload: HTMLElement;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private additonalLibrary: AdditionalPublicLibraryService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getTimeMatrices();
    this.listQRcodes();
    this.qrForm = this.formBuilder.group({
      duration: ['', Validators.required]
    });
  }

  closeDialog() {
    this.activeModal.close();
  }
  generateQRcode() {

    if (this.qrCodes.length > 0) {
      const modalRef = this.modalService.open(RemoveContent, { centered: true });
      modalRef.componentInstance.message = "Are you sure you want to generate new QR code?<br>New QR code will be generated for your modified preferences.";
      modalRef.componentInstance.title = "Generate QR";
      modalRef.componentInstance.successActionButtonName = "Continue";
      modalRef.result.then((response) => {
        if (response == 'success') {
          this.qrSubmit();
        }
      });
    } else {
      this.qrSubmit();
    }
  }

  qrSubmit() {
    this.submitted = true;
    if (!this.qrForm.valid || this.selectedQRcode) {
      return;
    }

    const params = {
      "user_outlet": {
        "current_qr_code_attributes":
        {
          "time_matrix_id": this.qrForm.get('duration').value
        }
      }
    }
    this.spinner.show();
    this.additonalLibrary.generateQRcode(this.user.id, params).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        this.ngOnInit();
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = "QR code generated successfully";
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Error occured during generating QR code";
      }
    }, (error) => {

    });
  }

  getTimeMatrices() {
    this.additonalLibrary.getTimeMatrices().subscribe((response) => {
      if (response.success) {
        this.timeMatrices = response.data.time_matrices;
      }
    });
  }

  listQRcodes() {
    this.isLoading = true;
    this.spinner.show()
    this.additonalLibrary.listQRcode(this.user.id).subscribe((response) => {
      if (response.success) {
        this.qrCodes = response.data.qr_codes;
        if (this.qrCodes.length > 0) {
          this.qrCodes = this.qrCodes.filter((element) => {
            return element.status == true;
          });
          this.selectedQRcode = this.qrCodes[0];
          if (this.selectedQRcode) {
            this.selectedQRcodeHTML = this._sanitizer.bypassSecurityTrustUrl( "data:image/png;base64," + this.selectedQRcode.data);
            this.qrForm.get('duration').setValue(this.selectedQRcode.time_matrix_id);
          }
        }
        this.isLoading = false;
        this.spinner.hide()
      } else {
        this.isLoading = false;
        this.spinner.hide()
      }
    });
  }

  matrixChanged(event) {
    if (event.target.value) {
      const qr = this.qrCodes.find((element) => {
        return element.time_matrix_id == event.target.value;
      });
      if (qr) {
        this.selectedQRcode = qr;
        this.selectedQRcodeHTML = this._sanitizer.bypassSecurityTrustUrl( "data:image/png;base64," + this.selectedQRcode.data);
      } else {
        this.selectedQRcode = '';
      }
    }
  }
  deactivateQRcode() {
    const modalRef = this.modalService.open(RemoveContent, { centered: true });
    modalRef.componentInstance.message = "Are you sure you want to deactivate this QR code?";
    modalRef.componentInstance.successActionButtonName = "Yes";

    modalRef.result.then((response) => {
      if (response == 'success') {
        const params = {
          "status": false,
          "ids": [this.selectedQRcode.id]
        }
        this.spinner.show();
        this.additonalLibrary.deleteQRcode(this.user.id, params).subscribe((response) => {
          this.spinner.hide();
          if (response.success) {
            this.listQRcodes()
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = "QR code deleted successfully.";
          } else {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Error occured during deleting QR code.";
          }
        }, (error) => {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = "Error occured during deleting QR code.";
          this.spinner.hide();
        });
      }
    });
  }

 async downQRcodePre() {
    // this.spinner.show();
    // setTimeout(() => {
    //   this.downloadQRCode()
    // }, 500);
    this.spinner.show();    
    var a = document.createElement("a");
    a.href = this.selectedQRcodeHTML.changingThisBreaksApplicationSecurity;
    a.download = "QR.png";
    await a.click();
    this.spinner.hide();
  }
  // async downloadQRCode() {
  //   await saveAsPng(document.getElementById('qrCodeDownload'), { filename: 'qr', printDate: true });
  //   this.spinner.hide();
  // }
}
